export default __webpack_public_path__ + "static/media/camera-house-small.4353f371.png";